<template>
    <div>
        <v-client-table :columns="columns" :options="options" :data="files">

            <template slot="file_title" slot-scope="props">
                <a :href="`/files/view/${props.row.id}`" target="_blank" v-if="can_view_in_browser(props.row)" title="View File">
                    <span v-if="props.row.file_title">{{ props.row.file_title }}</span>
                    <span v-else>{{ props.row.file_name }}</span>
                </a>
                <a :href="`/files/download/${props.row.id}`" v-else title="Dowload File">
                    <span v-if="props.row.file_title">{{ props.row.file_title }}</span>
                    <span v-else>{{ props.row.file_name }}</span>
                </a>
            </template>

            <template slot="id" slot-scope="props">
                <b-dropdown variant="default" size="sm">
                    <template #button-content>
                        <i class="fa fa-ellipsis-h"></i>
                    </template>
                    <b-dropdown-item :href="`/files/view/${props.row.id}`" target="_blank" v-if="can_view_in_browser(props.row)">View</b-dropdown-item>
                    <b-dropdown-item :href="`/files/download/${props.row.id}`">Download</b-dropdown-item>
                </b-dropdown>
            </template>

            <template slot="created_at" slot-scope="props">
                {{ props.row.created_at | moment('timezone', timezone, "MM/DD/YYYY hh:mm a") }}
            </template>

            <template slot="file_size" slot-scope="props">
                <span v-if="props.row.file_size !== null && props.row.file_size > 1000000">
                    {{ (props.row.file_size / 1000000).toFixed(2) }} MB
                </span>
                <span v-else-if="props.row.file_size !== null">
                    {{ (props.row.file_size / 1000).toFixed(2) }} KB
                </span>
            </template>

            <template slot="last_name" slot-scope="props">
                {{ props.row.first_name }} {{ props.row.last_name }}
            </template>

        </v-client-table>
    </div>
</template>

<script>
    export default {
        props: {
            files: {
                type: Array,
                required: true,
            },
        },

        data() {
            return {
                timezone: this.$root.timezone,
                columns: [
                    'id',
                    'file_title',
                    'file_ext',
                    'file_size',
                    'created_at',
                    'last_name'
                ],
                options: {
                    filterable: false,
                    orderBy: {
                        ascending: false,
                        column: 'created_at',
                    },
                    headings: {
                        id: 'Actions',
                        file_title: 'Name',
                        file_ext: 'Ext',
                        file_size: 'Size',
                        created_at: 'Created At',
                        last_name: 'Created By'
                    }
                }
            }
        },

        computed: {

        },

        methods: {
            can_view_in_browser(file_ext){
                //Setup
                var can_view_exts = [
                    'jpg',
                    'jpeg',
                    'png',
                    'gif',
                    'tiff',
                    'pdf',
                ];

                //Send it
                return can_view_exts.includes(file_ext);
            },

            can_view(file){
                //Set
                return file.is_sensitive == 0 || this.$root.hasPermission(this.$root.getRecordPlural(file.record_type)+'.view.sensitive')
            },

            can_edit(file){
                //Setup Table
                var table = this.$root.getRecordPlural(file.record_type);

                //Check if they can manage and either the file is not sensitive or the user has sensitive permissions
                if( this.$root.hasPermission(table+'.manage') && (file.is_sensitive == 0 || this.$root.hasPermission(table+'.view.sensitive')) )
                {
                    return true;
                }

                //Send true for now, need to check permissiosn and type
                return false;
            },
        },

        mounted() {

        }
    }
</script>

<style type="text/css" scope>
    .img-fluid {
        border: 1px solid #ccc;
    }
</style>
